import PropTypes from 'prop-types';
import React from 'react';
import "./TopBar.css";

const TopBar = ({text, links=[], children=null}) => (
    <div className="topbar">
        <div className="hero">{text}</div>
        <div className="grow"></div>
        {
            links.map(name => (
                <a key={name} href={"#" + name}>
                    <div className="button">{name}</div>
                </a>
            ))
        }
        {children}
    </div>
);

TopBar.propTypes = {
    text: PropTypes.string,
    links: PropTypes.array,
    children: PropTypes.element
};

export default TopBar;


// WEBPACK FOOTER //
// ./src/kpi/components/TopBar.jsx